var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    enableBackground: "new 0 0 90 90",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M44.895,80.552C26.357,80.519,9.769,69.435,2.852,52.382 c-0.834-2.055-1.462-4.215-1.954-6.378c-0.627-2.754,0.312-5.366,1.263-7.893C7.962,22.697,18.993,13.084,34.923,9.27 c21.508-5.15,43.863,6.463,52.188,26.924c0.836,2.054,1.477,4.209,1.979,6.371c0.643,2.752-0.267,5.371-1.221,7.9 c-5.973,15.842-17.355,25.479-33.808,29.134c-2.986,0.661-6.089,0.802-9.138,1.184C44.914,80.705,44.905,80.627,44.895,80.552z  M45.586,64.452c11.277-0.509,20.037-9.819,19.53-20.756c-0.521-11.232-9.786-19.951-20.705-19.484 c-11.251,0.48-20.011,9.79-19.53,20.753C25.373,56.164,34.701,64.942,45.586,64.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M32.927,44.286c0.016-6.641,5.439-12.033,12.093-12.025 c6.68,0.008,12.088,5.465,12.052,12.163c-0.036,6.628-5.487,12.007-12.142,11.981C38.301,56.379,32.912,50.938,32.927,44.286z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.a5fd341e3a40f853e185c129d5be32cc.svg";
export { ForwardRef as ReactComponent };